import Section from "../../components/section/Section";
import ContactsWrapper from "./components/contacts-wrapper/ContactsWrapper";

const CompanyDirectory = () => {
  return (
    <Section
      title="Company Directory"
      subtitle="Define and organize your company's directory, whether they are departments, teams, or individuals."
      content={
        <>
          <ContactsWrapper />
        </>
      }
      overrideStyle={{}}
    />
  );
};

export default CompanyDirectory;
